import { Link } from "react-router-dom";
import { latestUpdates } from "@/mocks/events";

export default function TickerBar() {
  const items = [...latestUpdates, ...latestUpdates];
  return (
    <div className="w-full bg-primary-950 text-background-50">
      <div className="flex w-full items-center">
        <div className="flex shrink-0 items-center gap-2 bg-accent-500 px-3 py-2.5 text-xs font-semibold text-background-50 md:px-5">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-live-line"></i>
          </span>
          <span className="whitespace-nowrap">最新通报</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-2.5">
          <div className="flex w-max animate-ticker items-center">
            {items.map((item, index) => (
              <Link
                key={`${item.eventId}-${index}`}
                to={`/events/${item.eventId}`}
                className="mx-5 inline-flex items-center gap-2 text-xs text-background-200 transition-colors hover:text-accent-300 md:text-sm"
              >
                <span className="text-accent-300">{item.time}</span>
                <span className="font-medium text-background-50">{item.actor}</span>
                <span className="whitespace-nowrap">{item.text}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}